import {
  URLBuilder1hwx1b9569i61 as URLBuilder,
  Urlowwyg1lanrqp as Url,
} from '../../../../../../ktor-ktor-http/io/ktor/http/URLUtils.mjs';
import {
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Companion_getInstancek1529r0btmjl as Companion_getInstance } from '../../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_getInstance1fjhglsqufscv as Companion_getInstance_0,
  HeadersBuilder3h7sn3kkvu98m as HeadersBuilder,
} from '../../../../../../ktor-ktor-http/io/ktor/http/Headers.mjs';
import { Channel3r72atmcithql as Channel } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { equals2v6cggk171b6e as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { Paire9pteg33gng7 as Pair } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { flatten2dh4kibw1u0qq as flatten } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { copyToArray2j022khrow2yi as copyToArray } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { PlatformUtils_getInstance8t6iqcjia1rj as PlatformUtils_getInstance } from '../../../../../../ktor-ktor-utils/io/ktor/util/PlatformUtils.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import {
  Companion_instance1xjg859pd52fi as Companion_instance,
  createFailure8paxfkfa5dc7 as createFailure,
  _Result___init__impl__xyqfz823vatsdepqb9n as _Result___init__impl__xyqfz8,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { toTypedArray3sl1vhn8ifta0 as toTypedArray } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *open($this, url, headers, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = URLBuilder(url);
  var tmp0_subject = url.i54_1;
  var tmp;
  if (tmp0_subject.equals(Companion_getInstance().u54_1)) {
    tmp = Companion_getInstance().w54_1;
  } else if (tmp0_subject.equals(Companion_getInstance().t54_1)) {
    tmp = Companion_getInstance().v54_1;
  } else if (tmp0_subject.equals(Companion_getInstance().v54_1) || tmp0_subject.equals(Companion_getInstance().w54_1)) {
    tmp = url.i54_1;
  } else {
    throw UnsupportedOperationException().a1('SOCKS is not a supported protocol');
  }
  this_0.s54(tmp);
  var newUrl = this_0.d37();
  var tmp_0 = newUrl.toString();
  // Inline function 'io.ktor.http.Companion.build' call
  Companion_getInstance_0();
  // Inline function 'kotlin.apply' call
  var this_1 = new (HeadersBuilder())();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = headers.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    this_1.m4o(element.w48_1, element.x48_1);
  }
  var tmp$ret$2 = this_1.d37();
  var socket = yield* awaitConnection($this, createWebSocket($this, tmp_0, tmp$ret$2), $completion);
  var messageChannel = Channel(2147483647);
  socket.onmessage = (messageEvent) => {
    var data = messageEvent.data;
    var tmp;
    if (!(data == null)) {
      if (typeof data === 'string')
        messageChannel.y1a(data);
      else {
        throw UnsupportedOperationException().a1('' + getKClassFromExpression(data).j1() + ' is currently unsupported');
      }
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
  socket.onclose = (it) => messageChannel.k1b();
  return new (DefaultWebSocketEngine$open$7())(messageChannel, socket);
}
function createWebSocket($this, urlString_capturingHack, headers) {
  // Inline function 'kotlin.collections.partition' call
  var this_0 = headers.j4o();
  var first = ArrayList().p2();
  var second = ArrayList().p2();
  var _iterator__ex2g4s = this_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (equals(element, 'sec-websocket-protocol', true)) {
      first.i2(element);
    } else {
      second.i2(element);
    }
  }
  var _destruct__k2r9zo = new (Pair())(first, second);
  var protocolHeaderNames = _destruct__k2r9zo.we();
  var otherHeaderNames = _destruct__k2r9zo.xe();
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList().p2();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = protocolHeaderNames.p1();
  while (_iterator__ex2g4s_0.q1()) {
    var element_0 = _iterator__ex2g4s_0.r1();
    var tmp0_safe_receiver = headers.h4o(element_0);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.i2(tmp0_safe_receiver);
    }
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_1 = flatten(destination);
  var protocols = copyToArray(this_1);
  var tmp;
  if (PlatformUtils_getInstance().u4n_1) {
    var ws_capturingHack = eval('require')('ws');
    var headers_capturingHack = new (DefaultWebSocketEngine$createWebSocket$headers_capturingHack$1())();
    headers.o4o((name, values) => {
      headers_capturingHack[name] = joinToString(values, ',');
      return Unit_instance;
    });
    tmp = new ws_capturingHack(urlString_capturingHack, protocols, {headers: headers_capturingHack});
  } else {
    // Inline function 'kotlin.check' call
    if (!otherHeaderNames.n1()) {
      var message = "Apollo: the WebSocket browser API doesn't allow passing headers. Use connectionPayload or other mechanisms.";
      throw IllegalStateException().o(toString(message));
    }
    tmp = new WebSocket(urlString_capturingHack, protocols);
  }
  return tmp;
}
function *awaitConnection($this, $receiver, $completion) {
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  return yield () => {
    var uCont = $completion;
    var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
    cancellable.v10();
    $l$block: {
      var continuation = cancellable;
      if (continuation.uw()) {
        break $l$block;
      }
      var eventListener = {_v: null};
      var removeEventListeners = () => {
        $receiver.removeEventListener('open', eventListener._v);
        $receiver.removeEventListener('error', eventListener._v);
        return Unit_instance;
      };
      eventListener._v = (event) => {
        var tmp;
        if (!continuation.uw()) {
          var tmp0_subject = event.type;
          var tmp_0;
          if (tmp0_subject === 'open') {
            var tmp0 = continuation;
            // Inline function 'kotlin.coroutines.resume' call
            // Inline function 'kotlin.Companion.success' call
            var value = $receiver;
            var tmp$ret$5 = _Result___init__impl__xyqfz8(value);
            tmp0.oc(tmp$ret$5);
            tmp_0 = removeEventListeners();
          } else if (tmp0_subject === 'error') {
            var tmp0_0 = continuation;
            // Inline function 'kotlin.coroutines.resumeWithException' call
            // Inline function 'kotlin.Companion.failure' call
            var exception = IllegalStateException().o(asString($this, event));
            var tmp$ret$7 = _Result___init__impl__xyqfz8(createFailure(exception));
            tmp0_0.oc(tmp$ret$7);
            tmp_0 = Unit_instance;
          }
          tmp = tmp_0;
        }
        return Unit_instance;
      };
      continuation.dz((it) => {
        removeEventListeners();
        var tmp;
        if (!(it == null)) {
          $receiver.close();
          tmp = Unit_instance;
        }
        return Unit_instance;
      });
      $receiver.addEventListener('open', eventListener._v);
      $receiver.addEventListener('error', eventListener._v);
    }
    return cancellable.fy();
  };
}
function asString($this, $receiver) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().l1();
  var tmp = JSON;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = ['message', 'target', 'type', 'isTrusted'];
  this_0.m1(tmp.stringify($receiver, tmp$ret$3));
  return this_0.toString();
}
var DefaultWebSocketEngine$open$7Class;
function DefaultWebSocketEngine$open$7() {
  if (DefaultWebSocketEngine$open$7Class === VOID) {
    class $ {
      constructor($messageChannel, $socket) {
        this.e6d_1 = $messageChannel;
        this.f6d_1 = $socket;
      }
      *w6c($completion) {
        return yield* this.e6d_1.b1b($completion);
      }
      u6c(data) {
        this.f6d_1.send(new Uint8Array(toTypedArray(data.f3x())));
      }
      v6c(string) {
        this.f6d_1.send(string);
      }
      l6() {
        this.f6d_1.close(1000);
        this.e6d_1.k1b();
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [0]);
    DefaultWebSocketEngine$open$7Class = $;
  }
  return DefaultWebSocketEngine$open$7Class;
}
var DefaultWebSocketEngine$createWebSocket$headers_capturingHack$1Class;
function DefaultWebSocketEngine$createWebSocket$headers_capturingHack$1() {
  if (DefaultWebSocketEngine$createWebSocket$headers_capturingHack$1Class === VOID) {
    class $ {}
    initMetadataForClass($);
    DefaultWebSocketEngine$createWebSocket$headers_capturingHack$1Class = $;
  }
  return DefaultWebSocketEngine$createWebSocket$headers_capturingHack$1Class;
}
var DefaultWebSocketEngineClass;
function DefaultWebSocketEngine() {
  if (DefaultWebSocketEngineClass === VOID) {
    class $ {
      *r6b(url, headers, $completion) {
        return yield* /*#__NOINLINE__*/open(this, Url(url), headers, $completion);
      }
    }
    initMetadataForClass($, 'DefaultWebSocketEngine', DefaultWebSocketEngine, VOID, VOID, [2, 1]);
    DefaultWebSocketEngineClass = $;
  }
  return DefaultWebSocketEngineClass;
}
//region block: exports
export {
  DefaultWebSocketEngine as DefaultWebSocketEngine2qlkcxmcddkl7,
};
//endregion

//# sourceMappingURL=JsWebSocketEngine.mjs.map
